import constants from "../../constants";
import { useContext, useState } from "react";
import useAxiosPrivate from "../useAxiosPrivate";
import AlertContext from "../../context/AlertContext";
// import useUploadLargeFileToS3 from "../useUploadLargeFileToS3";
import useCommonFunctionHooks from "../useCommonFunctionHooks";
import MobileViewSetUpHooks from "../InstructionPage/MobileViewSetUpHooks";
import useS3FileManagement from "../useS3FileManagement";


export default function CodingHeaderAdminSideHooks() {
  const Alert = useContext(AlertContext);

  const axios = useAxiosPrivate();
  const { folderName } = MobileViewSetUpHooks();
  const { getPreSignedUrl, deleteS3Objects } = useS3FileManagement();

  const { getHeaderDetailsForAxios, getCatchBlockDetails } =
    useCommonFunctionHooks();

  const [showAll, setShowAll] = useState(false);
  const [showProfile, setShowProfile] = useState(false);
  const [showProctoring, setShowProctoring] = useState(false);

  const [deleteImages, setDeleteImages] = useState({
    withKey: [],
    withOutKey: [],
  });

  const [deleteDPImages, setDeleteDPImages] = useState({
    withKey: [],
    withOutKey: [],
  });

  const handleProfileShow = () => setShowProfile(true);
  const handleProfileClose = () => setShowProfile(false);

  const handleProctoringClosePopup = () => {
    setShowProctoring(false);
    Alert.setProfile([]);
  };

  const handleApprove = () => {
    Alert.setComment("");
    Alert.setShowReject(false);
    Alert.setShowApprove(!Alert.showApprove);
  };

  const handleReject = () => {
    Alert.setComment("");
    Alert.setShowApprove(false);
    Alert.setShowReject(!Alert.showReject);
  };

  const accessDenied = () =>{
    Alert.setShowNotify({
      show: true,
      title: "Info",
      msg: "You can assign the score only after the test is submitted.",
    });
  }

  const getProctorData = () => {
    if (!showAll) {
      return Alert.profile.proctoringdatas?.filter(
        (data) => parseInt(data.probabilityofmatch) !== 100
      );
    } else {
      return Alert.profile.proctoringdatas;
    }
  };

  // const getDPData = () => {
  //   if (!showAll) {
  //     return Alert.profile.dpPics?.filter(
  //       (data) => parseInt(data.probabilityofmatch) !== 100
  //     );
  //   } else {
  //     return Alert.profile.dpPics;
  //   }
  // };

  const getImageData = () => {
    const details = JSON.parse(JSON.stringify(Alert.profile ?? "{}"));
    if (!showAll) {
      const filteredData = details?.proctoringdatas?.filter(
        (data) => parseInt(data.probabilityofmatch) !== 100
      );

      return {
        ...details,
        proctoringdatas: filteredData,
      };
    } else {
      return details;
    }
  };

  // const getDPImageData = () => {
  //   if (!showAll) {
  //     const filteredData = Alert.profile.dpPics?.filter(
  //       (data) => parseInt(data.probabilityofmatch) !== 100
  //     );

  //     return {
  //       ...Alert.profile,
  //       dpPics: filteredData,
  //     };
  //   } else {
  //     return Alert.profile;
  //   }
  // };

  const showSubmitButton = (status) => {
    if (
      status === constants.QUESTION_STATUS.RESUBMIT ||
      status === constants.QUESTION_STATUS.REATTEMPT_NEW_VERSION ||
      status === constants.QUESTION_STATUS.CONTINUE ||
      status === constants.QUESTION_STATUS.IN_PROGRESS
    ) {
      return true;
    } else {
      return false;
    }
  };

  const getPayLoadForProctoring = () => {
    let payLoad = {
      lpid: Alert.showBreadCrumbsData.lpId,
      libtypeid: Alert.showBreadCrumbsData.type,
      userid: Alert.showBreadCrumbsData.learnerId,
    };

    if (
      Alert.showBreadCrumbsData.type === constants.libTypeIds.CODING_CHALLENGE
    ) {
      payLoad.testid = Alert.showBreadCrumbsData.testId;
      payLoad.qnid = Alert.showBreadCrumbsData.questionId;
      payLoad.qnno = Alert.showBreadCrumbsData.questionNo;
      payLoad.testconfigid = Alert.showBreadCrumbsData.testConfigId;
    } else if (
      Alert.showBreadCrumbsData.type === constants.libTypeIds.ASSIGNMENT
    ) {
      payLoad.libid = Alert.showBreadCrumbsData.testId;
    } else {
      payLoad.qnid = Alert.showBreadCrumbsData.testId;
    }

    return JSON.stringify(payLoad);
  };

  const handleShowProctoring = () => {
    setShowProctoring(true);
    Alert.setIsLoaded(true);
    axios
      .post(
        "node/admin/userproctoring",
        getPayLoadForProctoring(),
        getHeaderDetailsForAxios()
      )
      .then(async (res) => {
        if (res.data === "") {
          Alert.setShowNotify({
            show: true,
            title: "Info",
            msg: "No data available",
          });
        } else {
          let data = res.data;

          let urlData = await getPreSignedUrl(
            `Proctoring/Registration/${Alert.learnerId}/${Alert.learnerId}.png`, undefined, "png", "GET"
          );
          data.registerUrl=urlData.url

          if (data.hasOwnProperty("proctoringdatas")) {
            for (let i = 0; i < data.proctoringdatas.length; i++) {
              let filePath = `Proctoring/${Alert.showBreadCrumbsData.testId}/`;

              if (
                parseInt(Alert.showBreadCrumbsData.type) ===
                constants.libTypeIds.CODING_CHALLENGE
              )
                filePath += `${Alert.showBreadCrumbsData.questionId}/${Alert.learnerId}/`;
              else filePath += `${Alert.learnerId}/`;

              filePath += data.proctoringdatas[i].imagename;

              let url = await getPreSignedUrl(filePath, undefined, filePath?.split(".")?.pop(), "GET");

              data.proctoringdatas[i].imagePresignedUrl = url.url;
              // Process the DP image
              if (data.dpPics && data.dpPics[i]) {
                let dpFilePath = `${folderName()}/proctoring/${
                  Alert.showBreadCrumbsData.testId
                }/`;
                if (
                  parseInt(Alert.showBreadCrumbsData.type) ===
                  constants.libTypeIds.CODING_CHALLENGE
                )
                  dpFilePath += `${Alert.showBreadCrumbsData.questionId}/${Alert.learnerId}/`;
                else dpFilePath += `${Alert.learnerId}/`;
                dpFilePath += data.dpPics[i].imagename;
                const dpUrl = await getPreSignedUrl(dpFilePath, "DP", dpFilePath?.split(".").pop(), "GET");
                // Add DP properties to the proctoring data item
                data.proctoringdatas[i].dpimagename = data.dpPics[i].imagename;
                data.proctoringdatas[i].dpimagePresignedUrl = dpUrl.url;
                data.proctoringdatas[i].dpmultifaces =
                  data.dpPics[i].multifaces;
                data.proctoringdatas[i].dpfacedetected =
                  data.dpPics[i].facedetected;
                data.proctoringdatas[i].dpphonedetected =
                  data.dpPics[i].phonedetected;
                data.proctoringdatas[i].dpexternaldevices =
                  data.dpPics[i].externaldevices;
                data.proctoringdatas[i].dpcreatedTimeStamp =
                  data.dpPics[i].createdTimeStamp;
              }
            }
          }

          // if (data.hasOwnProperty("dpPics")) {
          //   for (let i = 0; i < data.dpPics.length; i++) {
          //     let filePath = `dev/proctoring/${Alert.showBreadCrumbsData.testId}/${Alert.showBreadCrumbsData.questionId}/${Alert.learnerId}/${data.dpPics[i].imagename}`;

          //     let url = await getPreSignedUrl(filePath, "dp");

          //     data.dpPics[i].imagePresignedUrl = url;
          //   }
          // }

          res.data = data;
          Alert.setProfile(res.data);
        }
      })
      .catch((err) => {
        getCatchBlockDetails(err, "proctor");
      })
      .finally(() => Alert.setIsLoaded(false));
  };

  const handleSelectImage = (checked, imageName, dpimagename) => {
    let details = getImageData();
    // let dpDetails = getDPImageData();

    let imageNames = JSON.parse(JSON.stringify(deleteImages));

    let dpImageNames = JSON.parse(JSON.stringify(deleteDPImages));

    if (checked) {
      if (imageName === "all") {
        imageNames.withKey = [];
        imageNames.withOutKey = [];
        dpImageNames.withKey = [];
        dpImageNames.withOutKey = [];

        details.proctoringdatas = details.proctoringdatas.map((detail) => {
          detail.isChecked = true;

          // Proctoring image
          const fullPath = new URL(detail.imagePresignedUrl).pathname.slice(1);
          const pathWithoutFile = fullPath.substring(
            0,
            fullPath.lastIndexOf("/") + 1
          );
          imageNames.withKey.push({
            Key: `${pathWithoutFile}${detail.imagename}`,
          });
          imageNames.withOutKey.push(detail.imagename);

          // DP image (if exists)
          if (detail.dpimagePresignedUrl && detail.dpimagename) {
            const dpFullPath = new URL(
              detail.dpimagePresignedUrl
            ).pathname.slice(1);
            const dpPathWithoutFile = dpFullPath.substring(
              0,
              dpFullPath.lastIndexOf("/") + 1
            );
            dpImageNames.withKey.push({
              Key: `${dpPathWithoutFile}${detail.dpimagename}`,
            });
            dpImageNames.withOutKey.push(detail.dpimagename);
          }

          return detail;
        });
        // Alert.setProfile(details);
      } else {
        details.proctoringdatas = details.proctoringdatas.map((detail) => {
          if (detail.imagename === imageName) {
            detail.isChecked = true;
            const fullPath = new URL(detail.imagePresignedUrl).pathname.slice(
              1
            );
            const pathWithoutFile = fullPath.substring(
              0,
              fullPath.lastIndexOf("/") + 1
            );
            imageNames.withKey.push({ Key: `${pathWithoutFile}${imageName}` });
            imageNames.withOutKey.push(imageName);
            if (dpimagename) {
              const dpFullPath = new URL(
                detail.dpimagePresignedUrl
              ).pathname.slice(1);
              const dpPathWithoutFile = dpFullPath.substring(
                0,
                dpFullPath.lastIndexOf("/") + 1
              );
              dpImageNames.withKey.push({
                Key: `${dpPathWithoutFile}${dpimagename}`,
              });
              dpImageNames.withOutKey.push(dpimagename);
            }
          }

          return detail;
        });
        // setDeleteImages(imageNames);
        // setDeleteDPImages(dpImageNames);
        // Alert.setProfile(details);
      }
    } else {
      if (imageName === "all") {
        imageNames.withKey = [];
        imageNames.withOutKey = [];
        dpImageNames.withKey = [];
        dpImageNames.withOutKey = [];
        // Reset all images to unchecked
        details.proctoringdatas = details.proctoringdatas.map((detail) => {
          detail.isChecked = false;

          return detail;
        });
      } else {
        imageNames.withKey = imageNames.withKey.filter(
          (imgName) => !imgName.Key.includes(imageName)
        );
        imageNames.withOutKey = imageNames.withOutKey.filter(
          (imgName) => imgName !== imageName
        );
        details.proctoringdatas = details.proctoringdatas.map((detail) => {
          if (detail.imagename === imageName) detail.isChecked = false;

          return detail;
        });
        if (dpimagename) {
          dpImageNames.withKey = imageNames.withKey.filter(
            (imgName) => !imgName.Key.includes(dpimagename)
          );
          dpImageNames.withOutKey = imageNames.withOutKey.filter(
            (imgName) => imgName !== dpimagename
          );
        }
      }

      Alert.setProfile(details);
      // setDeleteImages(imageNames);
      // setDeleteDPImages(dpImageNames);
    }

    setDeleteImages(imageNames);
    setDeleteDPImages(dpImageNames);
  };

  const handleDeleteImg = async (event) => {
    event.preventDefault();
    try {
      Alert.setIsLoaded(true);

      let res = await axios.post(
        "node/admin/userproctoring/image",
        {
          imageNames: deleteImages.withOutKey,
          dpImageNames: deleteDPImages.withOutKey,
        },
        getHeaderDetailsForAxios()
      );

      if (res.data.resultCode === constants.RESULT_STATUS.SUCCESS) {
        let result = await deleteS3Objects(deleteImages.withKey);
        let dpResult;
        if (deleteDPImages.withKey.length > 0) {
          dpResult = await deleteS3Objects(deleteDPImages.withKey, "DP");
        } else {
          dpResult = "Success";
        }
        if (result === "Success" && dpResult === "Success") {
          Alert.setShowNotify({
            show: true,
            title: "Success",
            msg: res.data.msg,
          });

          let details = JSON.parse(JSON.stringify(Alert.profile));

          details.proctoringdatas = details.proctoringdatas?.filter(
            (detail) => !deleteImages.withOutKey.includes(detail.imagename)
          );

          Alert.setProfile(details);
          setDeleteImages({ withKey: [], withOutKey: [] });
          setDeleteDPImages({ withKey: [], withOutKey: [] });
        }
      } else if (
        res.data.resultCode === constants.RESULT_STATUS.TECHNICAL_ERROR
      ) {
        Alert.setShowNotify({
          show: true,
          title: "Error",
          msg: res.data.msg,
        });
      } else {
        Alert.setShowNotify({
          show: true,
          title: "Error",
          msg: "Something went wrong. Please try again later.",
        });
      }
    } catch (err) {
      getCatchBlockDetails(err);
    } finally {
      Alert.setIsLoaded(false);
    }
  };

  /* admin submit for mcq/desc */

  const adminsubmitAnswers = () => {
    let testtypeid = Alert.mcqAndDesTestAndLpId.libtypeid;

    if (
      testtypeid === constants.libTypeIds.SAQ ||
      testtypeid === constants.libTypeIds.LAQ
    ) {
      testtypeid = constants.libTypeIds.DESCRIPTIVE;
    }

    if (
      testtypeid === constants.libTypeIds.MCQ_MULTI ||
      testtypeid === constants.libTypeIds.MCQ_SINGLE
    ) {
      testtypeid = constants.libTypeIds.MCQ;
    }

    Alert.setIsLoaded(true);

    axios
      .post(
        "node/admin/test/submit",
        JSON.stringify({
          testtype: testtypeid,
          timeleft: Alert.rejectData.timeleft,
          lpid: parseInt(Alert.mcqAndDesTestAndLpId.cellobj.lpId),
          lpconfigid: Alert.mcqAndDesTestAndLpId.cellobj.lpConfigId,
          testid: parseInt(Alert.mcqAndDesTestAndLpId.cellobj.testId),
          learnerid: parseInt(Alert.mcqAndDesTestAndLpId.cellobj.learnerId),
          proctored:
            Alert.mcqAndDesTestAndLpId.cellobj.proctored ===
            constants.PROCTORING_MODE.TAB_CAM,
        }),
        {
          timeout: 30000,
          headers: {
            "Content-type": "application/json",
          },
        }
      )
      .then((res) => {
        if (res.data.resultCode === constants.RESULT_STATUS.SUCCESS) {
          Alert.setShowNotify({
            show: true,
            title: "Success",
            msg: res.data.message,
          });
        } else {
          Alert.setShowNotify({
            show: true,
            title: "Success",
            msg: res.data.message || "Something went wrong… Please, try again",
          });
        }
      })
      .catch((error) => {
        if (
          error.message.includes("504") ||
          error.message === "timeout of 30000ms exceeded"
        ) {
          Alert.setShowNotify({
            show: true,
            title: "Error",
            msg: "Something went wrong… program is taking too long to finish. Please, try again",
          });
        } else {
          getCatchBlockDetails(error);
        }
      })
      .finally(() => Alert.setIsLoaded(false));
  };

  const submitCodeTest = () => {
    Alert.setIsLoaded(true);
    // let baseurl =
    //   Alert.codeDetails.langid == constants.LANG_ID.Javascript
    //     ? process.env.REACT_APP_NODE_API
    //     : process.env.REACT_APP_CONTAINER_API;

    // let url =
    //   Alert.codeDetails.langname.toLowerCase() === "javascript"
    //     ? "node/admin/cc/submit"
    //     : Alert.codeDetails.langname.toLowerCase() === "c"
    //     ? "node/admin/c/submit"
    //     : Alert.codeDetails.langname.toLowerCase() === "cpp"
    //     ? "node/admin/cpp/submit"
    //     : Alert.codeDetails.langname.toLowerCase() === "python"
    //     ? "node/admin/python/submit"
    //     : "node/admin/java/submit";

    axios
      .post(
        "node/admin/cc/submit",
        JSON.stringify({
          learnerid: Alert.learnerId,
          qnid: Alert.codeDetails.qnid,
          langid: Alert.codeDetails.langid,
          testid: Alert.codeDetails.testid,
          timeleft: Alert.codeDetails.timeleft,
          lpconfigid: Alert.codeDetails.lpconfigid,
          testConfig: Alert.codeDetails.testconfigid,
          timedout: Alert.isAdminSubmitTimeout.current,
          proctored: Alert.codeDetails.proctored === 1,
        }),
        {
          timeout: 30000,
          headers: {
            "Content-type": "application/json",
            Authorization: localStorage.getItem("tokenKey"),
          },
        }
      )
      .then((res) => {
        Alert.setShowNotify({
          show: true,
          title: "Info",
          msg: "Submission successfull!",
        });
      })
      .catch((error) => {
        if (
          error.message.includes("504") ||
          error.message === "timeout of 30000ms exceeded"
        ) {
          Alert.setShowNotify({
            show: true,
            title: "Error",
            msg: "Something went wrong… program is taking too long to finish. Please, try again",
          });
        } else {
          getCatchBlockDetails(error);
        }
      })
      .finally(() => Alert.setIsLoaded(false));
  };

  const adminSubmitTest = () => {
    if (
      Alert.testDetail.libtypeid === constants.libTypeIds.SQL ||
      [constants.libTypeIds.MCQ, constants.libTypeIds.DESCRIPTIVE || constants.libTypeIds.MCQ, constants.libTypeIds.CODING_SNIPPET].includes(
        Alert.mcqAndDesTestAndLpId.libtypeid
      )
    ) {
      adminsubmitAnswers();
    } else {
      submitCodeTest();
    }
  };

  return {
    showAll,
    setShowAll,
    showProfile,
    deleteImages,
    handleReject,
    handleApprove,
    showProctoring,
    getProctorData,
    // getDPData,
    handleDeleteImg,
    setDeleteImages,
    adminSubmitTest,
    showSubmitButton,
    handleProfileShow,
    handleSelectImage,
    setShowProctoring,
    handleProfileClose,
    handleShowProctoring,
    handleProctoringClosePopup,
    accessDenied
  };
}
